/* BAM Motion v5 - extracted from snippets/bam-motion.liquid 2026-08-26.
   Logic is unchanged from the former inline <script> block. Loaded with defer,
   so it now runs after HTML parsing instead of blocking head parse. The IIFE
   is self-contained and exports no globals, so load order does not matter. */
(function(){
  function setupHeaderGlass(){
    var ticking = false;
    function onScroll(){
      if (window.scrollY > 8) document.documentElement.classList.add('bam-scrolled');
      else document.documentElement.classList.remove('bam-scrolled');
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking){ requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    onScroll();
  }

  function setupRipple(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.button--primary, button.primary, .shopify-payment-button__button');
      if (!btn || btn.dataset.bamNoRipple === '1') return;
      /* Skip quantity, cart, and gallery buttons */
      if (btn.closest('quantity-selector, quantity-input, [class*="quantity"], .product-gallery, [class*="gallery"], cart-items-component, cart-line-quantity')) return;
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      var r = document.createElement('span');
      r.className = 'bam-ripple';
      r.style.width = r.style.height = size + 'px';
      r.style.left = (e.clientX - rect.left - size/2) + 'px';
      r.style.top  = (e.clientY - rect.top  - size/2) + 'px';
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.appendChild(r);
      setTimeout(function(){ r.remove(); }, 600);
    }, { passive: true });
  }

  /* SAFE reveal targets - only headings + explicit text blocks. NO pictures, NO cards, NO quantities. */
  var SAFE_SELECTORS = [
    '.shopify-section h1',
    '.shopify-section h2',
    '.shopify-section h3',
    '.shopify-section [class*="text-block"]'
  ].join(',');

  /* Containers we never tag inside */
  var SKIP_SELECTORS = [
    'header','footer','#header-group','.bam-trust-strip','.bam-brands',
    '.product-card','.product-grid__item','.card-product','.collection-product-card','[class*="card-product"]',
    '.product-information','.product-details','.product__info','.product-gallery','[class*="gallery"]','[class*="product-image"]',
    'cart-items-component','cart-line-quantity','[class*="quantity"]',
    '.bam-internal-app','.bam-search'
  ].join(',');

  function tagReveals(){
    if (!document.body) return;
    var els = document.querySelectorAll(SAFE_SELECTORS);
    els.forEach(function(el){
      if (el.hasAttribute('data-bam-reveal')) return;
      if (el.closest(SKIP_SELECTORS)) return;
      var rect = el.getBoundingClientRect();
      if (rect.width < 60 || rect.height < 16) return;
      el.setAttribute('data-bam-reveal', '');
    });
  }

  var io = null;
  function setupObserver(){
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-bam-reveal]').forEach(function(el){ el.classList.add('is-revealed'); });
      return;
    }
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
    document.querySelectorAll('[data-bam-reveal]:not(.is-revealed)').forEach(function(el){ io.observe(el); });
  }

  /* AGGRESSIVE safety net: force visible after 1.2s no matter what */
  function forceAllVisible(){
    document.querySelectorAll('[data-bam-reveal]:not(.is-revealed)').forEach(function(el){
      el.classList.add('is-revealed');
    });
  }

  function init(){
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setupHeaderGlass();
    setupRipple();
    tagReveals();
    setupObserver();
    document.addEventListener('shopify:section:load', function(){
      tagReveals();
      if (io) document.querySelectorAll('[data-bam-reveal]:not(.is-revealed)').forEach(function(el){ io.observe(el); });
      setTimeout(forceAllVisible, 1000);
    });
    setTimeout(forceAllVisible, 1200);
    setTimeout(forceAllVisible, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
